interface WorkflowStatsProps {
  label: string;
  value: string;
}

export const WorkflowStats = ({ label, value }: WorkflowStatsProps) => (
  <div className="mt-4">
    <p className="font-medium text-neutral text-sm sm:text-base">{label}</p>
    <p className="text-3xl sm:text-4xl font-bold text-primary">{value}</p>
  </div>
);